import AppConstants from '../../config/app.constants';

class VaultBalanceController {

     /*@ngInject*/
    constructor($state, $q, $window) {
        this.$q = $q;
        this.$state = $state;
        this.$window = $window;

        this.model = {

        }
    }

    $onInit() {

    }

}

export default VaultBalanceController;


// WEBPACK FOOTER //
// ./client/app/components/vault_balance/vault_balance.controller.js